import React from 'react'
import { Tabs, Tab, Row, Col } from '@themesberg/react-bootstrap'
import Tenants from '../CreateTenant/components/Tenant'
import Credentials from '../CreateTenant/components/Credentials'
import useEditTenant from './hooks/useEditTenant'
import Deposit from '../CreateTenant/components/Deposit'
import Withdraw from '../CreateTenant/components/Withdraw'
import Preloader from '../../../components/Preloader'

const UpdateTenant = () => {
  const {
    selectedTab,
    setSelectedTab,
    tenantDetails,
    createTenantData,
    setCreateTenantData,
    loading,
    adminUserDetails,
    depositMethods
  } = useEditTenant()

  return (
    <>
      <Row>
        <Col className='d-flex'>
          <h3>Tenant:</h3>
          <h3> &nbsp;{tenantDetails && tenantDetails?.name}</h3>
        </Col>
        <Col className='d-flex justify-content-end'>
          <h3>Owner : {adminUserDetails?.firstName}{' '}{adminUserDetails?.lastName}</h3>
        </Col>
      </Row>

      {loading
        ? <Preloader />
        : (
          <Tabs
            activeKey={selectedTab}
            className='nav-light'
          >
            <Tab disabled eventKey='tenant' title='Tenant'>
              <div className='mt-5'>
                <Tenants
                  createTenantData={createTenantData}
                  setCreateTenantData={setCreateTenantData}
                  setSelectedTab={setSelectedTab}
                  isEdit
                />
              </div>
            </Tab>

            <Tab disabled eventKey='credentials' title='Credentials'>
              <div className='mt-5'>
                <Credentials
                  createTenantData={createTenantData}
                  setCreateTenantData={setCreateTenantData}
                  setSelectedTab={setSelectedTab}
                />
              </div>
            </Tab>

            <Tab disabled eventKey='deposit' title='Deposit'>
              <div className='mt-5'>
                <Deposit
                  createTenantData={createTenantData}
                  setCreateTenantData={setCreateTenantData}
                  setSelectedTab={setSelectedTab}
                  selectedTab={selectedTab}
                  depositMethods={depositMethods}
                />
              </div>
            </Tab>

            <Tab disabled eventKey='withdraw' title='Withdraw'>
              <div className='mt-5'>
                <Withdraw
                  createTenantData={createTenantData}
                  setCreateTenantData={setCreateTenantData}
                  setSelectedTab={setSelectedTab}
                  selectedTab={selectedTab}
                />
              </div>
            </Tab>

          </Tabs>)}
    </>
  )
}

export default UpdateTenant
